import { trigger, transition, style, animate, state } from '@angular/animations';
import { Component, Injectable, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ArrayService {
  constructor() { }
  public legacyList = [];

  addToList(menu: any) {
    this.legacyList.push(menu);
  }
  getUrlByAppId(appId: number) {
    return this.legacyList.find(x => x.appId == appId).originUrl;
  }
}
@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css'],
  animations: [trigger('expandCollapse', [
    state('collapsed', style({
      height: '0px',
      overflow: 'hidden'
    })),
    state('expanded', style({
      height: '*',
    })),
    transition('collapsed <=> expanded', [animate('400ms ease-in-out')])
  ])]

})
export class MenuItemComponent implements OnInit {
  @Input() public menuItem: any;
  @Input() public i: any;
  public isExpanded = false;
  public dynamicForm: any;
  public completeUrl: string;
  constructor(private service: ArrayService) { }

  ngOnInit() {
    if (this.menuItem.menU_TYPE === 1) {
      let menuItem = {
        originUrl: this.menuItem.origiN_URL,
        appId: this.menuItem.caM_APP_ID
      }
      this.service.addToList(menuItem);
    }
    if (this.menuItem.menU_TYPE === 4) {
      this.completeUrl = 'http://192.168.2.20/' + this.service.getUrlByAppId(this.menuItem.caM_APP_ID)+'/' + this.menuItem.url;
    }
    console.log(this.service.legacyList);
    console.log(this.completeUrl);

  }
  togglemenu() {
    this.isExpanded = !this.isExpanded;
    console.log('toggle');
    console.log(this.menuItem);

    if (!this.menuItem.childs.length) {
      this.postNavigate();
    }
  }
  public postNavigate() {
    console.log(this.completeUrl);
    //let baseUrl = this.menuItem.hosT_NAME ? this.menuItem.hosT_NAME : environment.coreBaseUrl;
    this.dynamicForm = '<form action="' + this.completeUrl +
      '" method="post" hidden><div><input name="SessionId" id="SessionId" type="text" value="' +
      localStorage.getItem("coreSessionId") + '" /><input name="Token" id="Token" type="text" value="' + localStorage.getItem("coreToken") + '" /> <button type="submit" id="submitBtn">Login</button> </div> </form>';
    setTimeout(() => {
      const submitbtn = document.getElementById("submitBtn");
      submitbtn.click()
    }, 1000);

  }
}


